import React from 'react'
import { withTranslation } from 'react-i18next'

import TextArea from '../'
import Button from 'app/components/ButtonDefault'

import './styles.scss'

const bc = 'text-area-with-confirm-and-cancel'

const TextAreaWithConfirmAndCancel = ({ onConfirm, onCancel, buttonsWrapperClass, t, ...rest }) => {
  const {
    meta: { error, touched },
  } = rest
  const disabled = error && touched

  return (
    <div>
      <TextArea {...rest} />
      <div className={`${bc}__buttons-wrapper`}>
        <Button style={{ marginBottom: 8 }} onClick={onCancel}>
          {t('Cancel')}
        </Button>
        <Button onClick={onConfirm} disabled={disabled}>
          {t('Confirm')}
        </Button>
      </div>
    </div>
  )
}

export default withTranslation('common')(TextAreaWithConfirmAndCancel)
